<div class="crypto-wallet-name">{{cryptoWallet?.name}}</div>
